/**
 * Hand-off for the open-the-book FLIP: BookCover stashes the tapped cover's screen rect just
 * before navigating to /book/:id; BookView reads it once on mount to animate the header from
 * that rect into place. Module-scoped + single-shot so a refresh / direct link simply has
 * nothing pending and renders statically.
 */
export interface OpeningBook {
  key: string;
  rect: { top: number; left: number; width: number; height: number };
  title: string;
}

let pending: OpeningBook | null = null;

export function setOpening(b: OpeningBook): void {
  pending = b;
}
/** Consume the pending opening rect (cleared after read). */
export function takeOpening(): OpeningBook | null {
  const p = pending;
  pending = null;
  return p;
}
